import dropdowncss from "../css/dropdown.module.css";
import commoncss from "../css/common.module.css";
import { useEffect, useState, useRef } from "react";
import { ReactComponent as DownArrowIcon } from "../assets/icons/down_arrow.svg";
import { ReactComponent as UpArrowIcon } from "../assets/icons/up_arrow.svg";
import { ReqFieldLabel } from "../../myfin_v2/components/mis";

// export default function Dropdown({
//   req=false,
//   class_="",
//   label,
//   options = [],
//   onSelect,
//   placeHolder,
//   selected = {},
// }) {
//   const [open, setOpen] = useState(false);
//   const [selectedOptionLabel, setSelectedOptionLabel] = useState(null);

//   // Automatically select the option if there's only one
//   useEffect(() => {
//     if (options.length === 1) {
//       const singleOption = options[0];
//       setSelectedOptionLabel(singleOption.label);
//       onSelect && onSelect({ label: singleOption.label, value: singleOption.value });
//     } else if (selected && selected.label) {
//       setSelectedOptionLabel(selected.label);
//     }
//   }, [options, selected, onSelect]);

//   const handleSelect = (option) => {
//     onSelect && onSelect({ label: option.label, value: option.value });
//     setSelectedOptionLabel(option.label);
//     setOpen(false);
//   };

//   return (
//     // <div className={`${dropdowncss.dropdown_wrapper} ${commoncss.w60pct}`}>
//       <div className={`${dropdowncss.dropdown_wrapper} ${class_}`}>
//       {label && <span className={dropdowncss.dropdown_label}> {req&&(<ReqFieldLabel/>)}&nbsp; {label}</span>}
//       <div className={`${dropdowncss.dropdown} ${class_}`} onClick={() => setOpen(!open)}>
//         <div
//           className={`${dropdowncss.dropdown_selected} ${
//             selectedOptionLabel ? dropdowncss.has_value : ""
//           }`}
//         >
//           {selectedOptionLabel || placeHolder}
//           <span className={dropdowncss.dropdown_arrow}>
//             {open ? <UpArrowIcon /> : <DownArrowIcon />}
//           </span>
//         </div>
//         <div
//           className={`${dropdowncss.dropdown_menu} ${open ? dropdowncss.open : ""}`}
//         >
//           {options.map((opt, i) => (
//             <div
//               key={i}
//               className={dropdowncss.dropdown_item}
//               onClick={() => handleSelect(opt)}
//             >
//               {opt.label}
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

export default function Dropdown({
  req = false,
  class_ = "",
  class2_ = "",
  label,
  options = [],
  onSelect,
  placeHolder,
  selected = {},
  selValue = null, // New prop
  style2 = {}, // New prop for inline styles
  disableAutoSelect = false, // Added prop to prevent auto-trigger
}) {
  const [open, setOpen] = useState(false);
  const [selectedOptionLabel, setSelectedOptionLabel] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    let labelToSet = null;

    if (options.length === 1) {
      labelToSet = options[0].label;
      if (selectedOptionLabel !== labelToSet) {
        setSelectedOptionLabel(labelToSet);
        if (!disableAutoSelect) {
          onSelect &&
            onSelect({ label: options[0].label, value: options[0].value });
        }
      }
    } else if (selValue) {
      const matchedOption = options.find(
        (opt) => {
          try {
            const optVal = JSON.parse(opt.value);
            const selVal = JSON.parse(selValue);
            if (optVal && selVal && optVal.notes_grp && selVal.notes_grp) {
              return optVal.notes_grp.toLowerCase() === selVal.notes_grp.toLowerCase();
            }
          } catch (e) {
            // ignore JSON parse errors
          }
          return String(opt.value).toLowerCase() === String(selValue).toLowerCase();
        }
      );
      if (matchedOption) {
        if (selectedOptionLabel !== matchedOption.label) {
          setSelectedOptionLabel(matchedOption.label);
          if (!disableAutoSelect) {
            onSelect &&
              onSelect({ label: matchedOption.label, value: matchedOption.value });
          }
        }
      } else {
        // Fallback: Use selValue directly if options is empty or not matching
        let displayLabel = String(selValue);
        try {
           const parsed = JSON.parse(selValue);
           if (parsed && typeof parsed.notes_grp === "string") {
             displayLabel = parsed.notes_grp;
           }
        } catch(e) {}
        
        if (displayLabel === "") {
          displayLabel = null;
        }

        if (selectedOptionLabel !== displayLabel) {
           setSelectedOptionLabel(displayLabel);
        }
      }
    } else if (selected) {
      const labelVal = typeof selected === "string" ? selected : selected.label;
      if (labelVal && labelVal !== selectedOptionLabel) {
        setSelectedOptionLabel(labelVal);
      }
    }
  }, [options, selected, selValue, onSelect, selectedOptionLabel, disableAutoSelect]);

  const handleSelect = (option) => {
    onSelect && onSelect({ label: option.label, value: option.value });
    setSelectedOptionLabel(option.label);
    setOpen(false);
  };

  return (
    <div
      ref={dropdownRef}
      className={`${dropdowncss.dropdown_wrapper} ${class_}`}
    >
      {label && (
        <span className={dropdowncss.dropdown_label}>
          {req && <ReqFieldLabel />} &nbsp; {label}
        </span>
      )}
      <div
        className={`${dropdowncss.dropdown} ${class_}`}
        onClick={() => setOpen(!open)}
      >
        {/* <div
          className={`${class2_} ${dropdowncss.dropdown_selected} ${
            selectedOptionLabel ? dropdowncss.has_value : ""
          }`}
        >
          {selectedOptionLabel || placeHolder}
          <span className={dropdowncss.dropdown_arrow}>
            {open ? <UpArrowIcon /> : <DownArrowIcon />}
          </span>
        </div> */}
        {/* <div
          className={`${class2_} ${dropdowncss.dropdown_selected} ${
            selectedOptionLabel ? dropdowncss.has_value : ""
          }`}
          data-tooltip={selectedOptionLabel || ""}
        > */}
        <div
          className={`${class2_} ${dropdowncss.dropdown_selected} ${
            selectedOptionLabel ? dropdowncss.has_value : ""
          }`}
          style={style2}
          {...(selectedOptionLabel && selectedOptionLabel.trim() !== ""
            ? { "data-tooltip": selectedOptionLabel }
            : {})}
        >
          <span className={dropdowncss.dropdown_selected_text}>
            {selectedOptionLabel || placeHolder}
          </span>
          <span className={dropdowncss.dropdown_arrow}>
            {open ? <UpArrowIcon /> : <DownArrowIcon />}
          </span>
        </div>

        <div
          className={`${dropdowncss.dropdown_menu} ${
            open ? dropdowncss.open : ""
          }`}
        >
          {options.map((opt, i) => (
            <div
              key={i}
              className={`${dropdowncss.dropdown_item} ${
                opt.label === selectedOptionLabel ? dropdowncss.active : ""
              }`}
              onClick={() => handleSelect(opt)}
            >
              {opt.label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// export default function Dropdown({
//   req = false,
//   class_ = "",
//   class2_ = "",
//   label,
//   options = [],
//   onSelect,
//   placeHolder,
//   selected = {},
//   selValue = null,
// }) {
//   const [open, setOpen] = useState(false);
//   const [selectedOptionLabel, setSelectedOptionLabel] = useState(null);
//   const dropdownRef = useRef(null);

//   // ================= CLICK OUTSIDE =================
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // ================= SYNC SELECTION =================
//   useEffect(() => {
//     let matchedOption = null;

//     // Auto-select if only one option
//     if (options.length === 1) {
//       matchedOption = options[0];
//     }

//     // Match by selValue
//     else if (selValue != null) {
//       matchedOption = options.find(
//         (opt) =>
//           String(opt.value).toLowerCase() ===
//           String(selValue).toLowerCase()
//       );
//     }

//     // Match by selected.label
//     else if (selected?.label) {
//       matchedOption = options.find(
//         (opt) => opt.label === selected.label
//       );
//     }

//     // ✅ FOUND → SET
//     if (matchedOption) {
//       if (selectedOptionLabel !== matchedOption.label) {
//         setSelectedOptionLabel(matchedOption.label);
//         onSelect?.({
//           label: matchedOption.label,
//           value: matchedOption.value,
//         });
//       }
//     }

//     // ❌ NOT FOUND → RESET
//     else if (selectedOptionLabel !== null) {
//       setSelectedOptionLabel(null);
//       onSelect?.(null); // reset parent
//     }
//   }, [options, selected, selValue]);

//   // ================= MANUAL SELECT =================
//   const handleSelect = (option) => {
//     onSelect?.({ label: option.label, value: option.value });
//     setSelectedOptionLabel(option.label);
//     setOpen(false);
//   };

//   return (
//     <div
//       ref={dropdownRef}
//       className={`${dropdowncss.dropdown_wrapper} ${class_}`}
//     >
//       {label && (
//         <span className={dropdowncss.dropdown_label}>
//           {req && <ReqFieldLabel />} &nbsp; {label}
//         </span>
//       )}

//       <div
//         className={`${dropdowncss.dropdown} ${class_}`}
//         onClick={() => setOpen(!open)}
//       >
//         <div
//           className={`${class2_} ${dropdowncss.dropdown_selected} ${
//             selectedOptionLabel ? dropdowncss.has_value : ""
//           }`}
//           data-tooltip={selectedOptionLabel || ""}
//         >
//           <span className={dropdowncss.dropdown_selected_text}>
//             {selectedOptionLabel || placeHolder}
//           </span>
//           <span className={dropdowncss.dropdown_arrow}>
//             {open ? <UpArrowIcon /> : <DownArrowIcon />}
//           </span>
//         </div>

//         <div
//           className={`${dropdowncss.dropdown_menu} ${
//             open ? dropdowncss.open : ""
//           }`}
//         >
//           {options.map((opt, i) => (
//             <div
//               key={i}
//               className={dropdowncss.dropdown_item}
//               onClick={() => handleSelect(opt)}
//             >
//               {opt.label}
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }
